export default __webpack_public_path__ + "static/media/offer-3.e4efce68.webp";